import { Box, Button, Container, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Slide, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material"
import Bottom from "../../Bottom";
import { forwardRef, ReactElement, Ref, useEffect, useState } from "react";
import api from "../../../utils/api_v2";
import LodingData from "../../../utils/LodingData";
import Pagination from "react-js-pagination";

import "../../../components/common/PaginationComponent.css";
import useStressStore from "../../../store/stressStores";
import { TransitionProps } from "@mui/material/transitions";
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { useNavigate } from "react-router-dom";
import tabbg from "../../../assets/images/tab_01.png"

// 모달창
const Transition = forwardRef(function Transition(
  props: TransitionProps & {
    children: ReactElement<any, any>;
  },
  ref: Ref<unknown>,
) {
  return <Slide direction="down" ref={ref} {...props} />;
});


const Stress = () => {

  const storeData: any = useStressStore();
  const navigate = useNavigate();

  useEffect(() => {
    getStressList();

    return () => {
      storeData.clear();
    }
  }, [])

  // 모달창
  const [open, setOpen] = useState(false);
  const handleOpen = (submitted: any, info: any, survey: any) => {
    storeData.setTargetInfo(info);
    storeData.setTargetSurvey(survey);

    if (!submitted) setTimeout(() => setOpen(true), 100)
    else navigate('result', { state: { assigned_uid: info.uid } })
  };
  const handleClose = () => {
    setOpen(false);
    storeData.modalClear();
  }

  function getStressList() {
    let familyId: any = localStorage.getItem('ownerFamID');

    LodingData(() => api.get(`customer/api/v2/surveys/stress/families/${encodeURIComponent(familyId)}`)
      .then(res => {
        // console.log(res);
        res.data.data.sort((a: any, b: any) => b.info.year - a.info.year);
        storeData.setStressList(res.data.data);
      })
      .catch(err => {
        console.log(err);
      }));
  }

  // function targetLow(info: any, survey: any) {
  //   storeData.setTargetInfo(info);
  //   storeData.setTargetSurvey(survey);
  // }

  function handleStressMain() {
    let famId: any = localStorage.getItem('ownerFamID');
    // navigate(`main?famId=${encodeURIComponent(famId)}&assigned_uid=${storeData.targetInfo.uid}&survey_uid=${storeData.targetSurvey.uid}`)

    const items = {
      famId: famId,
      assigned_uid: storeData.targetInfo.uid,
      survey_uid: storeData.targetSurvey.uid,
    }

    navigate('main', { state: items })
  }

  function handlePageChange(page: number) {
    storeData.setEncyclopediaListParams('pageNum', page - 1);
    getStressList();
  }

  return (
    <Container className="container">
      <Box sx={img} >
        <Grid container spacing={2} direction='row' justifyContent='center' alignItems={'center'} sx={{ overflow: 'hidden', height: 200, textAlign: 'center' }}>
          <Grid item container xs sx={{ pl: 0 }} direction='column' justifyContent='center'>
            <Typography className='topText' sx={{ fontSize: '2.2rem', color: '#8acd83', fontWeight: 900 }}>
              직무스트레스
            </Typography>
            <Typography sx={{ fontSize: '1.8rem', color: '#5ead3d', fontWeight: 500, }} gutterBottom>
              한국인 직무 스트레스 측정도구(Korean Occupational Stress Scale: KOSS)
            </Typography>
          </Grid>
        </Grid>
      </Box>

      <Typography sx={{ textAlign: 'center', mt: 4, mb: 4 }}>제출 된 응답은 수정이 불가능합니다.</Typography>

      <TableContainer>
        <Table size="small" className="Cl_table" sx={{width: '80%', ml: 'auto', mr: 'auto'}}>
          <TableHead>
            <TableRow>
              <TableCell>연도</TableCell>
              <TableCell>제목</TableCell>
              <TableCell>참여</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {
              storeData.stressList.length == 0
                ? <TableRow>
                  <TableCell colSpan={3}>해당하는 설문이 없습니다.</TableCell>
                </TableRow>
                : storeData.stressList && storeData.stressList.map((item: any, idx: number) => {
                  return (
                    <TableRow key={idx} onClick={() => { handleOpen(item.is_submitted, item.info, item.info.survey); }}>
                      <TableCell>{item.info.year}</TableCell>
                      <TableCell>{item.info.survey.title}</TableCell>
                      <TableCell>
                        {
                          item.is_submitted
                            ? <Typography sx={{background: '#999', width: '35%', borderRadius: 20, padding: '2px 0px', ml: 'auto', mr:'auto', color:'#fff', fontSize: 14}}>완료</Typography>
                            : <Typography sx={{background: '#fff', width: '35%', borderRadius: 20, padding: '2px 0px', ml: 'auto', mr:'auto', color:'#0087ff', fontSize: 14, border:'1px solid #0087ff'}}>대기</Typography>
                        }
                      </TableCell>
                    </TableRow>
                  )
                })
            }
          </TableBody>
        </Table>
      </TableContainer>

      {/* 모달창 */}
      {
        <Dialog
          open={open}
          onClose={handleClose}
          aria-describedby="alert-dialog-slide-description"
          TransitionComponent={Transition}

        >
          <DialogContent >
            <Container>
              <Box sx={{ textAlign: 'center' }}>
                <ErrorOutlineIcon sx={{fontSize: 36, color: '#0d6703', mb : 3}}/>
                <Box>
                  <Typography>{`[${storeData.targetInfo.year}년도 ${storeData.targetSurvey.title}]`}</Typography>
                  <Typography>완료가 필요합니다.</Typography>
                </Box>
              </Box>
            </Container>
          </DialogContent>

          <DialogActions>
            <Box sx={{alignItems: 'center'}}>
              <Button onClick={() => handleStressMain()} sx={{bgcolor: '#0d6703', color: '#fff', '&:hover' : {bgcolor: '#074300'}}}>확인</Button>
              {/* ${location.origin}/${view}/survey/stress/main?famId=${encodeURIComponent(familyId)}&assigned_uid=${assignedId}&survey_uid=${surveyUid} */}
              <Button onClick={handleClose}  sx={{bgcolor: '#ccc', color: '#888', ml: 1,'&:hover' : {bgcolor: '#aaa', color: '#333'}}}>닫기</Button>
            </Box>
          </DialogActions>
        </Dialog>
      }

      <Grid container className='foot_list'>
        <Pagination
          activePage={storeData.stressListParams.pageNum + 1} // 현재 페이지
          itemsCountPerPage={12} // 한 페이지에 보여줄 아이템 갯수
          totalItemsCount={storeData.stressListCount} // 총 아이템 갯수
          pageRangeDisplayed={10} // paginator의 페이지 범위
          prevPageText={"‹"} // "이전"을 나타낼 텍스트
          nextPageText={"›"} // "다음"을 나타낼 텍스트
          onChange={handlePageChange} // 페이지 변경을 핸들링하는 함수
        />
      </Grid>

      <Bottom />
    </Container>
  )
}

const img = {
  display: 'flex', p: 0, backgroundImage: `url(${tabbg})`, backgroundSize: 'cover', mb: 5, borderRadius: 2
}


export default Stress;